/* HappyFeet size parsing. Reads each listing's own size label; never assumes S/M/L mean the same across lines. */
(function () {
  if (window.HFSize) return;
  // Kids sizes wrap (12.5, 13, 1, 2 ...). Put toddler + kids on one line: 1 -> 14.5.
  function lin(n, g) { return g === 'k' && n < 7 ? n + 13.5 : n; }
  function unlin(n, g) { return g === 'k' && n >= 14 ? n - 13.5 : n; }
  var RE = /\b(women'?s|womens|women|ladies|girls|men'?s|mens|men|boys|kids|youth|toddler)(?:\s*&\s*(?:girls|boys))?\s*[-–:]?\s*T?(\d+(?:\.\d)?)\s*(?:[-–]\s*T?(\d+(?:\.\d)?)|(\+))/gi;
  function parse(val) {
    var out = {}, m, s = String(val);
    RE.lastIndex = 0;
    while ((m = RE.exec(s))) {
      var w = m[1].toLowerCase();
      var g = (w.indexOf('wom') === 0 || w === 'ladies' || w === 'girls') ? 'w' : (w.indexOf('men') === 0 || w === 'boys') ? 'm' : 'k';
      var a = parseFloat(m[2]);
      var b = m[3] ? parseFloat(m[3]) : a + 1;
      a = lin(a, g); b = lin(b, g);
      if (!out[g]) out[g] = [Math.min(a, b), Math.max(a, b)];
    }
    if (!out.k) {
      var t = s.match(/\bT(\d+(?:\.\d)?)\s*[-–]\s*T(\d+(?:\.\d)?)/i);
      if (t) out.k = [parseFloat(t[1]), parseFloat(t[2])];
    }
    return out;
  }
  function code(val) {
    var c = String(val).split(/\s+[-–]\s+|,/)[0].trim();
    return /^toddler/i.test(c) ? 'Toddler' : c;
  }
  // Whole shoe sizes a shopper can tap, in display numbers, for gender g across [lo, hi] on the linear scale.
  function chips(g, lo, hi) {
    var list = [];
    var cand = g === 'k' ? [5, 6, 7, 8, 9, 10, 11, 12, 13, 1, 2, 3, 4, 5, 6, 7].map(function (n, i) { return i < 9 ? n : n + 13.5; })
                         : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    cand.forEach(function (n) { if (n >= lo && n <= hi && list.indexOf(n) < 0) list.push(n); });
    return list;
  }
  // Index of the size value that fits linear shoe size n for gender g; falls back to the next size up.
  function fit(ranges, g, n) {
    var idx = -1, i;
    for (i = 0; i < ranges.length; i++) { var r = ranges[i][g]; if (r && n >= r[0] && n <= r[1]) { idx = i; break; } }
    if (idx < 0) {
      var best = Infinity;
      for (i = 0; i < ranges.length; i++) { var q = ranges[i][g]; if (q && q[0] > n && q[0] < best) { best = q[0]; idx = i; } }
    }
    return idx;
  }
  function fmt(r, g) { return r[g] ? unlin(r[g][0], g) + '–' + unlin(r[g][1], g) : ''; }
  window.HFSize = { parse: parse, lin: lin, unlin: unlin, code: code, fmt: fmt, chips: chips, fit: fit };
})();
